import { render, staticRenderFns } from "./ProposalInput.vue?vue&type=template&id=124a9837&scoped=true&"
import script from "./ProposalInput.vue?vue&type=script&lang=js&"
export * from "./ProposalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124a9837",
  null
  
)

export default component.exports